import React from 'react';

import { FetchPriority } from 'interfaces/html';

import { autoOptimizeImage } from 'utils/functions';
import { generateMediaQueryString } from 'utils/mediaQueryUtils/mediaQueryUtils';

export type SrcSet = {
  srcSet?: string;
  min?: number;
  max?: number;
};

interface CtaCardImageDefaultProps {
  imageUrl: string;
  imageAltText?: string;
  imageWidth?: number;
  loading?: 'lazy' | 'eager';
  srcSets?: SrcSet[];
  fetchPriority?: FetchPriority;
}

const DEFAULT_IMAGE_WIDTH = 365;

const CtaCardImage: React.FC<CtaCardImageDefaultProps> = ({
  imageUrl,
  imageAltText,
  imageWidth = DEFAULT_IMAGE_WIDTH,
  loading,
  srcSets,
  fetchPriority,
}) => {
  const img = (
    <img
      src={autoOptimizeImage(imageUrl, true, `${imageWidth}`)}
      alt={imageAltText ?? ''}
      loading={loading}
      fetchPriority={fetchPriority}
    />
  );

  if (!srcSets) {
    return img;
  }

  return (
    <picture>
      {srcSets.map(({ srcSet, min, max }) => (
        <source key={srcSet} srcSet={srcSet} media={generateMediaQueryString({ min, max })} />
      ))}
      {img}
    </picture>
  );
};

export default CtaCardImage;
